<template>
  <main class="advertising-page">
    <header>
      <div>
        <h1>广告运营</h1>
        <span>管理自愿观看广告、广告位与积分奖励；平台默认关闭。</span>
      </div>
      <a-button :loading="loading" @click="load"><i class="ri-refresh-line" />刷新</a-button>
    </header>
    <a-alert
      type="info"
      show-icon
      message="国内广告平台接入方式"
      description="当前使用 Mock 供应商验收全链路。推啊等真实供应商须在签约并配置回调凭据后启用，客户端不会直接发放积分。"
    />
    <section class="layout">
      <a-card title="奖励策略" class="policy-card" :loading="loading">
        <a-form layout="vertical" :model="policy">
          <a-form-item label="启用广告奖励"
            ><a-switch v-model:checked="policy.enabled"
          /></a-form-item>
          <a-form-item label="每日奖励上限（Credits）"
            ><a-input-number
              v-model:value="policy.dailyRewardLimitCredits"
              :min="0"
              :max="1000"
              :precision="3"
          /></a-form-item>
          <a-form-item label="奖励有效期（天）"
            ><a-input-number v-model:value="policy.rewardExpiryDays" :min="1" :max="365"
          /></a-form-item>
          <a-form-item label="变更原因"
            ><a-input v-model:value="policyReason" placeholder="例如：灰度开启广告奖励"
          /></a-form-item>
          <a-button type="primary" :loading="savingPolicy" @click="savePolicy">保存策略</a-button>
        </a-form>
      </a-card>
      <a-card title="广告活动" class="campaign-card">
        <template #extra
          ><a-button type="primary" @click="newCampaign"
            ><i class="ri-add-line" />新建活动</a-button
          ></template
        >
        <a-table
          :data-source="campaigns"
          :loading="loading"
          :columns="columns"
          :pagination="false"
          row-key="id"
          size="small"
          :scroll="{ x: 760 }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'reward'"
              ><strong>{{ record.rewardCredits }}</strong> Credits</template
            >
            <template v-else-if="column.key === 'status'"
              ><a-tag :color="record.enabled ? 'green' : 'default'">{{
                record.enabled ? '启用' : '停用'
              }}</a-tag></template
            >
            <template v-else-if="column.key === 'action'"
              ><a-button size="small" @click="edit(record)">编辑</a-button></template
            >
          </template>
        </a-table>
      </a-card>
    </section>
    <a-drawer
      v-model:open="drawerOpen"
      width="min(560px, 100vw)"
      :title="draft.id ? '编辑广告活动' : '新建广告活动'"
      :destroy-on-close="false"
    >
      <a-form layout="vertical" :model="draft">
        <a-form-item label="活动名称" required><a-input v-model:value="draft.name" /></a-form-item>
        <div class="two">
          <a-form-item label="供应商"
            ><a-select
              v-model:value="draft.provider"
              :options="providerOptions"
              @change="configureProvider" /></a-form-item
          ><a-form-item label="广告形式"
            ><a-select v-model:value="draft.format" :options="formatOptions"
          /></a-form-item>
        </div>
        <a-form-item label="广告位"
          ><a-checkbox-group v-model:value="draft.placements" :options="placementOptions"
        /></a-form-item>
        <a-form-item label="支持客户端"
          ><a-checkbox-group v-model:value="draft.clients" :options="clientOptions"
        /></a-form-item>
        <a-alert
          v-if="draft.provider === 'baidu_union'"
          class="baidu-tip"
          type="info"
          show-icon
          message="百度联盟仅投放 Web 展示广告"
          description="填写联盟代码位 ID 后以异步方式加载；不可用于每日奖励、桌面端或积分发放。"
        />
        <div class="two">
          <a-form-item label="奖励 Credits"
            ><a-input-number
              v-model:value="draft.rewardCredits"
              :min="draft.provider === 'baidu_union' ? 0 : 0.001"
              :max="1000"
              :precision="3" /></a-form-item
          ><a-form-item label="播放时长（秒）"
            ><a-input-number v-model:value="draft.durationSeconds" :min="1" :max="300"
          /></a-form-item>
        </div>
        <a-form-item label="展示标题" required><a-input v-model:value="draft.title" /></a-form-item>
        <a-form-item label="说明" required
          ><a-textarea v-model:value="draft.description" :maxlength="200"
        /></a-form-item>
        <div class="two">
          <a-form-item label="操作文案"><a-input v-model:value="draft.actionLabel" /></a-form-item
          ><a-form-item label="排序（小的优先）"
            ><a-input-number v-model:value="draft.sort" :min="0" :max="9999"
          /></a-form-item>
        </div>
        <a-form-item label="封面 URL（可选）"
          ><a-input v-model:value="draft.coverUrl"
        /></a-form-item>
        <a-form-item label="跳转 URL（可选）"
          ><a-input v-model:value="draft.targetUrl"
        /></a-form-item>
        <a-form-item v-if="draft.provider === 'baidu_union'" label="百度联盟代码位 ID" required
          ><a-input v-model:value="draft.providerSlotId" placeholder="例如 u6341556"
        /></a-form-item>
        <div class="two">
          <a-form-item label="开始时间"
            ><input v-model="startsAt" type="datetime-local" /></a-form-item
          ><a-form-item label="结束时间"
            ><input v-model="endsAt" type="datetime-local"
          /></a-form-item>
        </div>
        <a-form-item label="立即启用"><a-switch v-model:checked="draft.enabled" /></a-form-item>
      </a-form>
      <template #footer
        ><a-space
          ><a-button @click="drawerOpen = false">取消</a-button
          ><a-button type="primary" :loading="savingCampaign" @click="saveCampaign"
            >保存活动</a-button
          ></a-space
        ></template
      >
    </a-drawer>
  </main>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import type { AdvertisingCampaignView, AdvertisingPolicy } from 'shared';
import { adminApi } from '@/api';
type Draft = AdvertisingCampaignView;
const blank = (): Draft => ({
  id: '',
  name: '',
  provider: 'mock',
  format: 'video',
  placements: ['daily_reward'],
  clients: ['web', 'desktop'],
  rewardCredits: 1,
  durationSeconds: 15,
  title: '',
  description: '',
  actionLabel: '观看广告',
  coverUrl: null,
  targetUrl: null,
  providerSlotId: null,
  enabled: false,
  startsAt: null,
  endsAt: null,
  sort: 0,
});
const campaigns = ref<AdvertisingCampaignView[]>([]);
const policy = reactive<AdvertisingPolicy>({
  enabled: false,
  dailyRewardLimitCredits: 5,
  rewardExpiryDays: 90,
  timezone: 'Asia/Shanghai',
});
const policyVersion = ref(0);
const policyReason = ref('');
const savingPolicy = ref(false);
const loading = ref(false);
const savingCampaign = ref(false);
const drawerOpen = ref(false);
const draft = reactive<Draft>(blank());
const startsAt = ref('');
const endsAt = ref('');
const columns = [
  { title: '活动', dataIndex: 'name' },
  { title: '形式', dataIndex: 'format' },
  { title: '奖励', key: 'reward' },
  { title: '状态', key: 'status' },
  { title: '操作', key: 'action', fixed: 'right' },
];
const providerOptions = [
  { value: 'mock', label: 'Mock（验收）' },
  { value: 'tuia', label: '推啊（待接入）' },
  { value: 'baidu_union', label: '百度联盟（Web 展示）' },
  { value: 'self_hosted', label: '自营广告' },
];
const formatOptions = [
  { value: 'video', label: '视频' },
  { value: 'image', label: '图片' },
  { value: 'interactive', label: '互动' },
];
const placementOptions = [
  { value: 'daily_reward', label: '每日奖励' },
  { value: 'workspace_left', label: '工作台左联' },
  { value: 'workspace_right', label: '工作台右联' },
  { value: 'marketplace_sponsor', label: '商店赞助位' },
  { value: 'marketplace_partner', label: '商店合作位' },
];
const clientOptions = [
  { value: 'web', label: 'Web' },
  { value: 'desktop', label: '桌面端' },
];
function toInput(value: string | null): string {
  return value ? value.slice(0, 16) : '';
}
function toIso(value: string): string | null {
  return value ? new Date(value).toISOString() : null;
}
async function load(): Promise<void> {
  loading.value = true;
  try {
    const [items, saved] = await Promise.all([
      adminApi.get<AdvertisingCampaignView[]>('/admin/advertising/campaigns'),
      adminApi.get<{ value: AdvertisingPolicy; version: number }>('/admin/advertising/policy'),
    ]);
    campaigns.value = items;
    Object.assign(policy, saved.value);
    policyVersion.value = saved.version;
  } catch {
    message.error('广告运营数据加载失败');
  } finally {
    loading.value = false;
  }
}
function newCampaign(): void {
  Object.assign(draft, blank());
  startsAt.value = '';
  endsAt.value = '';
  drawerOpen.value = true;
}
function edit(item: AdvertisingCampaignView): void {
  Object.assign(draft, { ...item, placements: [...item.placements], clients: [...item.clients] });
  startsAt.value = toInput(item.startsAt);
  endsAt.value = toInput(item.endsAt);
  drawerOpen.value = true;
}
function configureProvider(): void {
  if (draft.provider !== 'baidu_union') return;
  draft.clients = ['web'];
  draft.placements = draft.placements.filter((placement) => placement !== 'daily_reward');
  draft.rewardCredits = 0;
}
async function savePolicy(): Promise<void> {
  if (!policyReason.value.trim()) return void message.warning('请填写策略变更原因');
  savingPolicy.value = true;
  try {
    const result = await adminApi.patch<{ version: number }>('/admin/advertising/policy', {
      value: { ...policy },
      version: policyVersion.value,
      reason: policyReason.value.trim(),
    });
    policyVersion.value = result.version;
    message.success('广告奖励策略已保存');
  } catch {
    message.error('保存失败，可能已被其他管理员修改');
  } finally {
    savingPolicy.value = false;
  }
}
async function saveCampaign(): Promise<void> {
  savingCampaign.value = true;
  try {
    const payload = { ...draft, startsAt: toIso(startsAt.value), endsAt: toIso(endsAt.value) };
    const saved = draft.id
      ? await adminApi.patch<AdvertisingCampaignView>(
          `/admin/advertising/campaigns/${draft.id}`,
          payload,
        )
      : await adminApi.post<AdvertisingCampaignView>('/admin/advertising/campaigns', payload);
    const index = campaigns.value.findIndex((item) => item.id === saved.id);
    if (index >= 0) campaigns.value.splice(index, 1, saved);
    else campaigns.value.unshift(saved);
    drawerOpen.value = false;
    message.success('广告活动已保存');
  } catch (error) {
    message.error((error as { message?: string }).message ?? '活动保存失败');
  } finally {
    savingCampaign.value = false;
  }
}
onMounted(() => {
  void load();
});
</script>

<style scoped>
.advertising-page {
  max-width: 1280px;
  margin: 0 auto;
  padding: 32px;
}
.advertising-page > header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.advertising-page h1 {
  margin: 0 0 7px;
  color: var(--aw-text);
  font-size: 28px;
  letter-spacing: -0.03em;
}
.advertising-page header span {
  color: var(--aw-text-secondary);
}
.advertising-page > :deep(.ant-alert) {
  margin-bottom: 16px;
}
.layout {
  display: grid;
  grid-template-columns: 330px minmax(0, 1fr);
  gap: 16px;
}
.two {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.two :deep(.ant-form-item) {
  min-width: 0;
}
.two input {
  width: 100%;
  min-height: 32px;
  border: 1px solid var(--aw-border);
  border-radius: 6px;
  padding: 4px 8px;
  color: var(--aw-text);
  background: var(--aw-surface);
}
@media (max-width: 900px) {
  .advertising-page {
    padding: 20px 14px;
  }
  .layout {
    grid-template-columns: 1fr;
  }
  .two {
    grid-template-columns: 1fr;
  }
}
</style>
